<template>
  <div class="d-flex flex-column ga-10 mb-4">
    <CompanyFeatures />

    <EditCompanySettlementWindow
      v-if="posthog?.isFeatureEnabled('enable-company-close-time-updating')"
    />

    <EditCompanyFeeDestination
      v-if="posthog?.isFeatureEnabled('enable-company-update-fee-destination')"
    />

    <CompanyDiscounts
      v-if="deal"
      :deal-rates="deal"
      :is-loading="isCompanyRatesLoading"
      @update="updateDealRates"
    />

    <CompanyCredits v-if="deal" :deal-rates="deal" />

    <CompanyRates
      v-if="posthog?.isFeatureEnabled('enable-deal-rate-updating') && !!deal"
      :deal-rates="deal"
      :is-loading="isCompanyRatesLoading"
      @update="updateDealRates"
    />

    <BlockCompany />
  </div>
</template>

<script setup lang="ts">
import { DealRates, MerchantUpdateRatesRequest } from "@tableyeti/merchant-service";
import { AxiosError } from "axios";
import { PostHog } from "posthog-js";
import { ref, inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useYetipayApi } from "@/composables/useYetipayApi";
import { useApplicationStore } from "@/store/application";

const { t } = useI18n();
const { api, currentMerchantId } = useYetipayApi();
const applicationStore = useApplicationStore();

const posthog = inject<PostHog>("posthog");

const isCompanyRatesLoading = ref(false);
const deal = ref<DealRates | undefined>(undefined);

onMounted(async () => {
  deal.value = await api!.merchantGetRates(currentMerchantId).then((res) => res.data);
});

const updateDealRates = async (updateRates: MerchantUpdateRatesRequest) => {
  try {
    isCompanyRatesLoading.value = true;

    await api!.merchantUpdateRates(currentMerchantId!, updateRates);
    deal.value = await api!.merchantGetRates(currentMerchantId!).then((res) => res.data);

    applicationStore.notifyUser({
      message: t("companies.staff.rates.successMessage"),
      type: "success",
    });
  } catch (error: unknown) {
    let message = t("companies.staff.rates.errorMessage");
    if (error instanceof AxiosError && error.response?.data?.error) {
      message += `: ${error.response?.data?.error}`;
    }
    applicationStore.notifyUser({ message, type: "error" });
  } finally {
    isCompanyRatesLoading.value = false;
  }
};
</script>
